<template>
    <div class="company-list-wrap full-h full-w " :class="{'toggle-bar':!toggleBar}">
        <h3 class="title-group">客户List</h3>
        <div class="search-bar">
            <el-input placeholder="请输入客户名称搜索" v-model="tempQuery.search"  @keyup.enter.native="submitSearch" @clear="submitSearch" clearable>
                <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
            </el-input>
        </div>
        <ul class="company-list"  v-loading="dataLoading" style="height: calc(100% - 130px);">
            <li :class="!activeItem.customer_id?'active':''" v-if="dataList.length>0" class="all-item" @click="checkAll">全部</li>
            <li class="tac" v-else>暂无数据</li>
            <li v-for="(item, index) in dataList" :key="index" @click="checkItem(item)" :class="activeItem.customer_id==item.customer_id?'active':''" class="clear-both list-wrap pointer relative">
                <span class="company-name inline-block ellipsis">{{item.company_name}}</span>
                <span class="count-text inline-block fr">{{item.bind_num}}</span>
            </li>
           
        </ul>
        <div class="bar-box" @click="handleToggleBar" :title="toggleBar ? '收起' : '展开'">
            <i :class="[ toggleBar ? 'el-icon-arrow-left': 'el-icon-arrow-right']"></i>
        </div>
        <div class="company-page mt10 tac">
            <el-pagination
                :disabled="dataLoading"
                :current-page="queryData.pn"
                :page-size="queryData.rn"
                layout="prev, pager, next"
                small
                @current-change="handleCurrentChange"
                hide-on-single-page
                background
                :pager-count="5"
                :total="totalCnt">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import API from '@/api/baseInfo/customerAppV2.js';

    export default {
        name: "CompanyListCard",
        props:{
            activeItem:Object,
        },
        data(){
            return {
                dataLoading:false,
                queryData:{
                    search:'',
                    pn:1,
                    rn:10,
                },
                tempQuery:{
                    search:'',
                },

                dataList:[],
                totalCnt:0,
                toggleBar: false
            }
        },
        created(){
            // this.submitSearch();
        },
        mounted(){
            let $companyList = document.querySelector('ul.company-list');
            let elementHeight = $companyList.clientHeight;
            let rowNum = parseInt( elementHeight / 26) - 1;
            this.queryData.rn = rowNum>10?rowNum:10;
            this.submitSearch();
        },
        methods:{
            handleToggleBar() {
                this.toggleBar = !this.toggleBar;
                this.$nextTick(()=> {
                    this.$emit('calcTableHeight')
                })
            },
            submitSearch(){
                console.log('submitSearch');
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.getDataList();
            },
            getDataList(){
                this.dataLoading = true;
                API.getCompanyList({
                    search: this.queryData.search,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res=>{
                    console.log('getCompanyList',res);
                    let resData = res.data||{};
                    this.dataList = resData.list||[];
                    this.dataLoading = false;
                    this.totalCnt = resData.totalCnt||0;
                },err=>{
                    console.log('getCompanyList err',err);
                    this.$message.error(err.info||'请求失败');
                    this.dataLoading = false;
                    this.dataList = [];
                    this.totalCnt = 0;
                })
            },
            handleCurrentChange(val){
                this.queryData.pn= val;
                this.getDataList();
            },
            checkAll(){
                this.$emit('checked',{});
            },
            checkItem(item){
                this.$emit('checked',item);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .company-list-wrap{
       width: 280px;
        overflow: hidden;
        position: relative;
        &.toggle-bar{
             width: 20px;
             *:not(.bar-box){
                 opacity: 0;
             }
        }
        .title-group{
            line-height: 32px;
            text-indent: 6px;
            border-bottom: solid 1px #ccc;
        }
        .search-bar{
            // padding: 10px 5px;
            padding: 10px 20px 10px 10px;
        }
        ul.company-list{
            padding: 0 0 0 10px;
            margin-right: 20px;
            overflow: hidden;
            overflow-y: auto;
           
            .all-item{
                background-color: #e8eaec;
            }
            li{
                height: 26px;
                line-height: 26px;
                text-indent: 10px;
                width: 100%;
                cursor: pointer;
                color: #606266;
                &.active{
                    background-color: #cfe6ff;
                    color: #409EFF;
                }
                &:hover{
                    color: #409EFF;
                }
                .company-name{
                    width: 180px;
                }
                .count-text{
                    padding: 0 6px;
                    position: absolute;
                    right: 0;
                }
            }
            
        }
        .bar-box {
            * {
                opacity: 1 !important;
            }
            position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #b3b3b3;
            cursor: pointer;
            font-size: 20px;
        }
    }
</style>
